import React, { Component } from 'react';
import common from 'ui-react-common';

const appConfig = common.config;
const api = common.services.coreAPIInstance;
const { ScriptLoader, scripts } = common.ui.components.scriptLoader;

class Recaptcha extends Component {
    render() {
        return (
            <ScriptLoader
                scriptName={scripts.googleRecaptchaUi}
                api={api}
                apiKey={appConfig.googleSiteKey}
            />
        );
    }
}

export default Recaptcha;
